var map = {
	"./0.png": 62,
	"./1.png": 63,
	"./10.png": 64,
	"./11.png": 65,
	"./2.png": 66,
	"./3--.png": 67,
	"./3-.png": 68,
	"./3.png": 69,
	"./4.png": 70,
	"./5.png": 71,
	"./6.png": 72,
	"./7.png": 73,
	"./8.gif": 74,
	"./9.png": 75,
	"./base.psd": 76,
	"./bazarvakil.jpg": 77,
	"./cafe.jpg": 78,
	"./eram.jpg": 79,
	"./hafiz.jpg": 80,
	"./intro.gif": 81,
	"./karimkhan.jpg": 82,
	"./lobbey.gif": 83,
	"./lobbey1.jpg": 84,
	"./lobbey2.jpg": 85,
	"./lobbey3.jpg": 86,
	"./lobbey4.jpg": 87,
	"./lobbey5.jpg": 88,
	"./merto-s.jpg": 89,
	"./naghsherostam.jpg": 90,
	"./narenjestan.jpg": 91,
	"./nasiralmolk.jpg": 92,
	"./qr.png": 93,
	"./restaurant.jpg": 94,
	"./room-2Bed-double-F.jpg": 95,
	"./room-2Bed-double-F2.jpg": 96,
	"./room-2Bed-double-F3.jpg": 97,
	"./room-2Bed-double.jpg": 98,
	"./room-2Bed-double_compressed.mp4": 99,
	"./room-2Bed-twin.jpg": 100,
	"./room-2Bed-twin_compressed.mp4": 101,
	"./room-3Bed-double.jpg": 102,
	"./room-3Bed-double_compressed.mp4": 103,
	"./room-3Bed-tripple.jpg": 104,
	"./room-3Bed-tripple_compressed.mp4": 105,
	"./room-e-F.jpg": 106,
	"./room-e.jpg": 107,
	"./room-sweet-apar.jpg": 108,
	"./room-sweet-apar_compressed.mp4": 109,
	"./room-sweet.jpg": 110,
	"./room-sweet_compressed.mp4": 111,
	"./saadi.jpg": 112,
	"./salon.jpg": 113,
	"./shahcheragh.jpg": 114,
	"./takhtejamshid.jpg": 115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61;